import $ from 'jquery';

export default class SlickCarousel {
  init () {
    // console.log('SlickCarousel init');

    $('[data-slick-carousel]').each((index, object) => {
      const blockId = $(object).data('slick-carousel');

      $(`[data-slick-carousel=${blockId}]`).slick({
        fade: true,
        dots: true,
        adaptiveHeight: true,
      });
    })

    $('[data-slick-product-images]').each((index, object) => {
      const blockId = $(object).data('slick-product-images');

      $(`[data-slick-product-images=${blockId}]`).slick({
        fade: true,
        dots: false,
        adaptiveHeight: false,
      });
    })
  }
}
